import styled from "styled-components";

const DropDownRadio = styled.label`
`;

export default DropDownRadio;